import React, { useEffect, useState } from "react";
import * as Styles from "./styles";
import Header from "./Header";
import Footer from "./Footer";

interface Props {
  onClose: () => void;
  handleZerarPV: () => void;
  isLoadingZerarPV?: boolean;
}

const ZerarPVModal: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Header onClose={() => props?.onClose()} />
      <Footer
        onClose={() => props?.onClose()}
        handleZerarPV={props.handleZerarPV}
        isLoadingZerarPV={props.isLoadingZerarPV}
      />
    </Styles.Container>
  );
};

export default ZerarPVModal;
